import React from 'react';
import { useController } from 'react-hook-form';

function Textarea({
	name,
	control,
	defaultValue,
	placeholder,
	register,
	className,
}) {
	const {
		field,
		fieldState: { error },
	} = useController({
		name,
		control,
		rules: register,
		defaultValue: defaultValue,
	});
	return (
		<div>
			<textarea
				className={className}
				placeholder={placeholder}
				{...field}
			></textarea>
			{error && (
				<span className='input__message text-[1.2rem] block  text-red-600 -mt-5 mb-6'>
					{error.message}
				</span>
			)}
		</div>
	);
}
export default Textarea;
